export class LogsDeliberation{

    constructor(
        private q_IAD:number,
        private q_TCys:number,
        private q_eBus:number,
        private q_DLog:number
    ){}
}